import configUtils from "./configUtils";
import { createStore } from "vuex";

import oneUtils from "../../gcdm-one-library/gcdm-one-utils/src/bootstrap";

 interface ConfigParams {
  client?: string;
  language: string;
  country: string;
  brand: string;
}



 interface Message {
  type: "ERROR" | "WARNING" | "SUCCESS" | "INFO" | "BIRTHDAY";
  content: string | null;
  prefix: string | null;
  suffix: string | null,
  click: Function | null
}




export default createStore({
  state: {
    loggedIn: false,
    message: {
      type: "ERROR",
      content: "",
      prefix: null,
      suffix: null,
      click: null
    },
    localizationCountry: '',
    user: {},
    originalUser: {},
    dealers: [],
    originalUrl: '',
    queryParams: {},
    configurationParams: {
      client: "",
      language: oneUtils.properties.DEFAULT_FALLBACK_LANGUAGE,
      country: "",
      brand: oneUtils.properties.DEFAULT_FALLBACK_BRAND,
    },
    configurations: {
      base: {},
      client: {},
      current: {config:{}}
    },
    componentAction: {
      action: '',
      options: {}
    },
    oneSelectOpenUid: null
  },
  getters: {
    getQueryParams: (state) => {
      return state.queryParams;
    },
    getUser: (state) => {
      return state.user;
    },
    getLoggedIn: (state) => {
      return state.loggedIn;
    },
    getLocalizationCountry: (state) => {
      return state.localizationCountry;
    },
    getOriginalUser: (state) => {
      return state.originalUser;
    },
    getDealers: (state) => {
      return state.dealers;
    },
    getOriginalUrl: (state) => {
      return state.originalUrl;
    },
    getConfig: (state) => {
      return state.configurations.current.config;
    },
    getConfigurations: (state) => {
      return state.configurations;
    },
    getConfigurationParams: (state): ConfigParams => {
      return state.configurationParams;
    },
    getCurrentConfig: (state) => {
      return state.configurations.current;
    },
    getMessage: (state) => {
      return state.message;
    },
    getComponentAction: (state) => {
      return state.componentAction;
    },
    getOneSelectOpenUid: (state) => {
      return state.oneSelectOpenUid;
    },
    translate: (state) => (key) => {
      return configUtils.translate(
        state.configurations,
        state.configurationParams,
        key
      );
    },
    configure: (state) => (key) => {
      const confOutputOld = configUtils.configureReplace(
        state.configurations,
        state.configurationParams,
        key
      );
      const confOutput = configUtils.configure(
        state.configurations,
        state.configurationParams,
        key
      );
      return confOutput;
    },
    brandClass: () => () => {
      return oneUtils.utils.getBrandAndDarkModeClasses();
    }
  },
  actions: {
    setupUser: ({ commit, state }, user) => {
      const parsedUser = oneUtils.userUtils.normalizeUser(user, state.user, state.configurationParams.country);
      commit("setUser", JSON.parse(JSON.stringify(parsedUser)));
      commit("setOriginalUser", JSON.parse(JSON.stringify(parsedUser)));
    },
    setupContactPolicyConsents: ({ commit, state }, contactPolicyConsents) => {
      const user = state.user;
      const originalUser = state.originalUser;

      user["contactPolicyConsents"] = contactPolicyConsents;
      originalUser["contactPolicyConsents"] = contactPolicyConsents;
      commit("setUser", JSON.parse(JSON.stringify(user)));
      commit("setOriginalUser", JSON.parse(JSON.stringify(originalUser)));
    },
    setupDealers: ({ commit, state }, dealers) => {
      commit("setDealers", dealers);
    },
    setupOriginalUrl:({ commit, state }, url)=>{
      url = oneUtils.utils.removeURLParameter(url, 'email');
      if (url.includes('change password') || url.includes('activation')) {
          return;
      } else {
          commit("setOriginalUrl", url);
      }
    },
    setupQueryParams: ({ commit, state }, queryParams) => {
      const mergerQueryParams = oneUtils.utils.mergeWithPriority(
        state.queryParams,
        queryParams
      );
      commit("setQueryParams", mergerQueryParams);
    },
    setupConfigParams: ({ commit, state }, configParams: ConfigParams) => {
      const mergedConfigurations = oneUtils.utils.mergeWithPriority(
        state.configurationParams,
        configParams
      );
      commit("setConfigParams", mergedConfigurations);
    },
    setupBaseConfig: ({ commit }, baseConfig) => {
      commit("setBaseConfig", baseConfig);
    },
    setupLanguages: ({ commit, state }, languageConfig) => {
      const merged = oneUtils.utils.mergeWithPriority(
        state.configurations.base,
        languageConfig
      );
      commit("setBaseConfig", merged);
    },
    setupClientConfig: ({ commit }, clientConfig) => {
      commit("setClientConfig", clientConfig);
    },
    setupOneSelectOpenUid: ({ commit }, uid) => {
      commit("setOneSelectOpenUid", uid);
    },
    mergeCurrentConfig: ({ commit, state }) => {
      const merged = oneUtils.utils.mergeWithPriority(
        state.configurations.base,
        state.configurations.client
      );
      commit("setCurrentConfig", merged);
    },
    showMessage: ({ commit }, message: Message) => {
      commit("setMessage", message);
    },
    setupComponentAction: ({ commit }, componentAction) => {
      commit("setComponentAction", componentAction);
    },
    clearMessage: ({ commit }) => {
      commit("setMessage", { type: "INFO", message: null });
    },
    clearComponentAction: ({ commit }) => {
      commit(
        "setComponentAction", 
        {
          action: '', 
          options: {}
        }
      );
    },
    setupLocalizationCountry: ({ commit }, country) => {
      commit("setLocalizationCountry", country);
    },
    login:({commit}) =>{
      commit("setLoggedIn", true);
    },
    logout:({commit}) =>{
      commit("setLoggedIn", false);
    }
  },
  mutations: {
    setLoggedIn(state, logged){
      state.loggedIn = logged;
    },
    setUser(state, user) {
      state.user = user;
    },
    setOriginalUser(state, user) {
      state.originalUser = user;
    },
    setDealers(state, dealers) {
      state.dealers = dealers;
    },
    setOriginalUrl(state, url) {
      state.originalUrl = url;
    },
    setQueryParams(state, queryParams) {
      state.queryParams = queryParams;
    },
    setConfigParams(state, configParams) {
      state.configurationParams = configParams;
    },
    setBaseConfig(state, baseConfig) {
      state.configurations.base = baseConfig;
    },
    setClientConfig(state, clientConfig) {
      state.configurations.client = clientConfig;
    },
    setLocalizationCountry(state, localizationCountry) {
      state.localizationCountry = localizationCountry;
    },
    setCurrentConfig(state, currentConfig) {
      state.configurations.current = currentConfig;
    },
    setMessage(state, message) {
      state.message = message;
    },
    setComponentAction(state, componentAction) {
      state.componentAction = componentAction;
    },
    setOneSelectOpenUid(state, uid) {
      state.oneSelectOpenUid = uid;
    }
  },
});

